import React, { useEffect, useMemo, useState } from "react";
// import "./PersonalDetails.css";
import { toast } from "sonner";
import { CustomModal } from "components/modals/ModalBox";
import { MultiSelect } from "components/form";
import { Select } from "common/InputForm";
import {
  activityDetailApi,
  addActivityApi,
  updateActivityApi,
} from "services/activity";

const formTeething = {
  GUMS: "Gum",
  BITE: "Biting",
};

const ManageActivity = ({
  _id,
  type,
  onClose,
  isOpen,
  getListHandler,
  propertyTab,
}) => {
  const isEditable = useMemo(() => type === "EDIT", [type]);
  const [formFields, setFormFields] = useState({
    uploadedImage: null,
    image: "",
    name: "",
    description: "",
    category: "MOTOR-SKILLS",
    youtubeLink: "",
    isFree: false,
    // language: propertyTab,
    teething: [],
    motorSkills: [],
    speech: [],
    ageGroup: [],
  });

  const fetchData = async () => {
    try {
      const { data } = await activityDetailApi({ _id });
      if (data?.success) {
        const detail = data?.data;
        setFormFields((prev) => ({
          ...prev,
          name: detail?.name,
          description: detail?.description,
          category: detail?.category,
          youtubeLink: detail?.youtubeLink,
          isFree: detail?.isFree,
          teething: detail?.recommendations?.teething?.map((item) => ({
            value: item,
            label: formTeething[item],
          })),
          motorSkills: detail?.recommendations?.motorSkills?.map((item) => ({
            value: item,
            label: formTeething[item],
          })),
          speech: detail?.recommendations?.speech?.map((item) => ({
            value: item,
            label: formTeething[item],
          })),
          ageGroup: detail?.ageGroup?.map((item) => ({
            value: item,
            label: `${item} Months`,
          })),
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  console.log({ formFields });

  useEffect(() => {
    if (isEditable) {
      fetchData();
    }

    return () => {
      setFormFields({
        uploadedImage: null,
        image: "",
        name: "",
        description: "",
        category: "MOTOR-SKILLS",
        youtubeLink: "",
        isFree: false,
        teething: [],
        motorSkills: [],
        speech: [],
        ageGroup: [],
      });
    };
  }, [isOpen]);

  // onChangeHandler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "number") {
      const numericValue = value.replace(/\D/g, "");
      setFormFields({ ...formFields, number: numericValue });
    } else {
      setFormFields({ ...formFields, [name]: value });
    }
  };

  // Error Handler
  const errorHandler = () => {
    let isValid = true;

    if (!formFields?.name) {
      isValid = false;
      toast.error("Please Enter Name");
      return;
    }

    if (!formFields?.description) {
      isValid = false;
      toast.error("Please Enter Description");
      return;
    }

    if (!formFields?.category) {
      isValid = false;
      toast.error("Please Select Category");
      return;
    }

    // if (!formFields?.youtubeLink) {
    //   isValid = false;
    //   toast.error("Please Enter Youtube Link");
    //   return;
    // }

    if (!formFields?.ageGroup?.length) {
      isValid = false;
      toast.error("Please Select Age Group");
      return;
    }

    if (!formFields?.uploadedImage && !isEditable) {
      isValid = false;
      toast.error("Please Upload Image");
      return;
    }

    return isValid;
  };

  const createRequest = async () => {
    if (errorHandler()) {
      try {
        const formData = new FormData();
        const payload = {
          ...formFields,
          language: propertyTab,
          teething: formFields?.teething?.map((item) => item.value),
          motorSkills: formFields?.motorSkills?.map((item) => item.value),
          speech: formFields?.speech?.map((item) => item.value),
          ageGroup: formFields?.ageGroup?.map((item) => item.value),
          image: formFields?.uploadedImage,
        };

        delete payload?.uploadedImage;

        for (const key in payload) {
          if (
            key === "teething" ||
            key === "motorSkills" ||
            key === "speech" ||
            key === "ageGroup"
          ) {
            formData.append(key, JSON.stringify(payload[key]));
          } else {
            formData.append(key, payload[key]);
          }
        }

        const { data } = await addActivityApi(formData);
        if (data?.success) {
          toast.success(data?.message);
          onClose();
          getListHandler();
        } else {
          toast.error(data?.message);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const updateRequest = async (e) => {
    if (errorHandler()) {
      try {
        const formData = new FormData();
        const payload = {
          ...formFields,
          language: propertyTab,
          teething: formFields?.teething?.map((item) => item.value),
          motorSkills: formFields?.motorSkills?.map((item) => item.value),
          speech: formFields?.speech?.map((item) => item.value),
          ageGroup: formFields?.ageGroup?.map((item) => item.value),
          ...(formFields?.uploadedImage && {
            image: formFields?.uploadedImage,
          }),
        };

        delete payload?.uploadedImage;
        if (payload?.image?.length === 0) {
          delete payload?.image;
        }

        for (const key in payload) {
          if (
            key === "teething" ||
            key === "motorSkills" ||
            key === "speech" ||
            key === "ageGroup"
          ) {
            formData.append(key, JSON.stringify(payload[key]));
          } else {
            formData.append(key, payload[key]);
          }
        }

        formData.append("_id", _id);
        const { data } = await updateActivityApi(formData);
        if (data?.success) {
          toast.success(data?.message);
          onClose();
          getListHandler();
        } else {
          toast.error(data?.message);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  // onSubmitHandler
  const onSubmitHandler = async (e) => {
    e.preventDefault();
    console.log({ type });

    if (type === "CREATE") {
      createRequest();
    } else {
      updateRequest();
    }
  };

  return (
    <CustomModal className={"lg"} show={isOpen} handleClose={onClose}>
      <div className="personal_details_parents" style={{ padding: 0 }}>
        <div className="personal_form_wrap ">
          <h4>{isEditable ? "Update" : "Create"} Activity</h4>

          <button className="button" onClick={(e) => onSubmitHandler(e)}>
            {isEditable ? "Update" : "Create"}
          </button>
        </div>

        <form>
          <div className="form_field_wrap choose_file">
            <div className="form_field">
              <label htmlFor="fname" className="label">
                Image *
              </label>
              <input
                type="file"
                name="name"
                className="input"
                accept="image/*"
                onChange={(e) =>
                  setFormFields((rev) => ({
                    ...rev,
                    uploadedImage: e.target.files[0],
                  }))
                }
              />
            </div>

            <div className="form_field">
              <label htmlFor="fname" className="label">
                Name *
              </label>
              <input
                type="text"
                name="name"
                className="input"
                onChange={onChangeHandler}
                value={formFields?.name}
              />
            </div>

            <div className="form_field">
              <label htmlFor="password" className="label">
                Description *
              </label>
              <input
                type="text"
                name="description"
                className="input"
                onChange={onChangeHandler}
                value={formFields?.description}
              />
            </div>
          </div>

          <div className="form_field_wrap">
            <div className="form_field">
              <label htmlFor="phn_number" className="label">
                Category *
              </label>
              <Select
                name="category"
                value={formFields?.category}
                onChange={onChangeHandler}
              >
                <option value="MOTOR-SKILLS">Motor Skills</option>
                <option value="SENSORY-PLAN">Sensory Plan</option>
                <option value="SOCIAL_SKILLS">Social Skills</option>
                <option value="COGNITIVE-DEVELOPMENT">
                  Cognitive Development
                </option>
              </Select>
            </div>

            <div className="form_field">
              <label htmlFor="password_con" className="label">
                Youtube Link
              </label>
              <input
                type="text"
                name="youtubeLink"
                className="input"
                onChange={onChangeHandler}
                value={formFields?.youtubeLink}
              />
            </div>
          </div>
          <div className="form_field_wrap">
            <div className="form_field">
              <MultiSelect
                label="Age Group *"
                Options={[
                  // { value: "0-12", label: "0-12 Weeks" },
                  // { value: "16-24", label: "16-24 Weeks" },
                  // { value: "28-36", label: "28-36 Weeks" },
                  // { value: "40-46", label: "40-46 Weeks" },
                  // { value: "48-72", label: "48-72 Weeks" },
                  // { value: "72-96", label: "72-96 Weeks" },
                  { value: "0-3", label: "0-3 Months" },
                  { value: "4-6", label: "4-6 Months" },
                  { value: "7-9", label: "7-9 Months" },
                  { value: "10-12", label: "10-12 Months" },
                  { value: "13-15", label: "13-15 Months" },
                  { value: "16-18", label: "16-18 Months" },
                  { value: "19-21", label: "19-21 Months" },
                  { value: "22-24", label: "22-24 Months" },
                ]}
                onChange={(e) =>
                  setFormFields((rev) => ({ ...rev, ageGroup: e }))
                }
                value={formFields?.ageGroup}
              />
            </div>
            <div className="form_field"></div>
          </div>

          <h5>Recommendations (Optional)</h5>
          <div className="form_field_wrap">
            <div className="form_field">
              <MultiSelect
                label="Teething"
                Options={[
                  { value: "GUMS", label: "Gum" },
                  { value: "BITE", label: "Biting" },
                ]}
                onChange={(e) =>
                  setFormFields((rev) => ({ ...rev, teething: e }))
                }
                value={formFields?.teething}
              />
            </div>
            <div className="form_field">
              <MultiSelect
                label="Motor Skills"
                Options={[
                  { value: "GUMS", label: "Gum" },
                  { value: "BITE", label: "Biting" },
                ]}
                onChange={(e) =>
                  setFormFields((rev) => ({ ...rev, motorSkills: e }))
                }
                value={formFields?.motorSkills}
              />
            </div>
          </div>
          <div className="form_field_wrap">
            <div className="form_field">
              <MultiSelect
                label="Speech"
                Options={[
                  { value: "GUMS", label: "Gum" },
                  { value: "BITE", label: "Biting" },
                ]}
                onChange={(e) =>
                  setFormFields((rev) => ({ ...rev, speech: e }))
                }
                value={formFields?.speech}
              />
            </div>
            <div className="form_field">
              <label htmlFor="fname" className="label">
                Show in free plan
              </label>
              <input
                type="checkbox"
                name="isFree"
                className="checkbox"
                onChange={e => setFormFields((rev) => ({ ...rev, isFree: e.target.checked }))}
                checked={formFields?.isFree}
              />
            </div>
          </div>
        </form>
        <div className="form_border_bottom"></div>
      </div>
    </CustomModal>
  );
};

export default ManageActivity;
